import { ScreenSize } from "Core/Responsive/Responsive.types";
import { useMediaQuery } from "react-responsive";

export const useSmallScreen = () => useMediaQuery({ maxWidth: ScreenSize.Small });
